import React from 'react';
import { array } from 'prop-types';

import SCNotificationBar, { DesktopInfo, MobileInfo } from './styles';

NotificationBar.propTypes = {
    notStarted: array   //  eslint-disable-line
};

NotificationBar.defaultProps = {
  notStarted: [],
};

function NotificationBar(props) {
  return (
    <SCNotificationBar>
      <DesktopInfo>
        {props.notStarted.map(
          name =>
            `${(props.notStarted.indexOf(name) !== 0 && '&') || ''} ${name} `
        )}
      </DesktopInfo>
      <MobileInfo>Alla deltagare</MobileInfo>
      &nbsp;har ännu inte påbörjat sin ansökan.
    </SCNotificationBar>
  );
}

export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/NotificationBar/NotificationBar.js